import $ from 'jquery';

import { getBuildVersionToShow } from '../spdConfig';

import { Loader } from './loader';
import { Speaker } from './speaker';
import * as Configuration from './testConfiguration';
import { FullScreen } from './fullScreen';

declare let speaker: Speaker;
declare let testConfiguration: Configuration.TestConfiguration;

export type Tools = {
  powered?: boolean;
  lange?: boolean;
  speaker?: boolean;
  help?: boolean;
  mode?: boolean;
  logout?: boolean;
  version?: boolean;
  fullscreen?: boolean;
  refresh?: boolean;
  demo?: boolean;
};

const defaultTools: Tools = {
  logout: false,
  powered: true,
  lange: true,
  speaker: true,
  mode: true,
  help: true,
  version: true,
  fullscreen: true,
  refresh: true,
  demo: false,
};

export class FooterTools {
  public static addTools(tools: Tools = defaultTools) {
    Loader.loadContentWithVersion(
      '#tools',
      'template/tools-template.mst',
      { ...tools, fullscreen: true, public: testConfiguration.public },
      function () {
        $('#tools_lange').val(testConfiguration.lange);
        FooterTools.setSpeakerIcon();
        FooterTools.showPowered(tools.powered);
        FooterTools.showVersion(tools.version);
        FooterTools.showFooter(tools.powered || tools.version);
        FooterTools.setFullScreenTool();
        FullScreen.addFullscreenChangeEvent(() =>
          FooterTools.setFullScreenTool(),
        );
      },
    );
  }

  public static setFullScreenTool() {
    if (FullScreen.isOpenFullscreen()) {
      $('#fullscreen').hide();
    } else {
      $('#fullscreen').show();
    }
  }

  public static showVersion(show = false) {
    if (show) {
      $('#version').html('Version: ' + getBuildVersionToShow());
      $('#version').show();
    } else {
      $('#version').hide();
    }
  }

  public static showPowered(show = false) {
    if (show) {
      $('#powered').show();
    } else {
      $('#powered').hide();
    }
  }

  public static showFooter(show = false) {
    if (show) {
      $('#footer').show();
    } else {
      $('#footer').hide();
    }
  }

  public static setSpeakerIcon() {
    if (speaker.isON()) {
      $('#speakerON').hide();
      $('#speakerOFF').show();
    } else {
      $('#speakerOFF').hide();
      $('#speakerON').show();
    }
  }
  public static setModeIcon(brightMode: boolean) {
    if (brightMode) {
      $('#mode-dark').hide();
      $('#mode-bright').show();
    } else {
      $('#mode-bright').hide();
      $('#mode-dark').show();
    }
  }
}
